import React, { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated } from '../../ProtectedRoute/index'
import { logout } from '../../../actions/authAction';
import logo from '../../../assets/icons/MetaBrief_horizontal_RBG.jpg'

const Sidebar = () => {
  const dispatch = useDispatch();
  const history = useHistory()
  const [inputMenu, setMenu] = useState(false);
  const [displayBlock, setDisplayBlock] = useState('none');
  const { error, user, logoutError } = useSelector((state) => state.auth);
  useEffect(() => {
    if (logoutError) {
      alert.error(logoutError);
      //dispatch({ type: LOGOUT_RESET });
    }
    let menu = (localStorage.getItem("activeMenu")) ? localStorage.getItem("activeMenu") : "dashboard";
    setMenu(menu);
  }, [logoutError, error]);
  const handleLogout = () => {
    dispatch(logout(history));
  };

  const makeActive = (menuItem, e) => {
    // e.target.elements.class="active";
    localStorage.setItem("activeMenu", menuItem);
    setMenu(menuItem);

  }
  const handleChangeMenu = (value) => {
    // e.target.elements.class="active";
    const valueUpdate = value === 'none' ? 'block' : 'none';
    setDisplayBlock(valueUpdate)
    localStorage.setItem("activeMenu", 'masters');
    setMenu('masters');
  }

  return (
    <div id="left-sidebar" className="sidebar">
      <div className="navbar-brand">
        <img src={logo} alt="Meta" className="img-fluid logo" />
        <button type="button" className="btn-toggle-offcanvas btn btn-sm btn-default float-right"><i className="lnr lnr-menu fa fa-chevron-circle-left"></i></button>
      </div>
      <div className="sidebar-scroll">
        <div className="user-account">
          <div className="user_div" style={{ "borderRadius": "90%", "height": "100px", "width": "110px" }}>
            <img src={user?.profile_pic_url} style={{ "borderRadius": "90%", "height": "90px" }} className="user-photo" alt="User" />
          </div>
          <div className="dropdown">
            <span>Welcome,</span>
            <a href="#" className="dropdown-toggle user-name" data-toggle="dropdown"><strong>{user?.name}</strong></a>
            <ul className="dropdown-menu dropdown-menu-right account">
              <li><Link to="profile"><i className="icon-user"></i>My Profile</Link></li>
              <li><Link to="change-password"><i className="icon-user"></i>Change Password</Link></li>
              {/* <li><a href="#"><i className="icon-settings"></i>Settings</a></li> */}
              <li className="divider"></li>
              {isAuthenticated() && (
                <li onClick={() => handleLogout()}>
                  <a className="icon-menu" >
                    <i className="icon-power"></i> Logout
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
        <nav id="left-sidebar-nav" className="sidebar-nav">
          <ul id="main-menu" className="metismenu">
            <li className={(inputMenu === "dashboard") ? "active" : ""} onClick={(e) => makeActive("dashboard", e)}><Link to="/dashboard"><i className="icon-home"></i><span>Dashboard</span></Link></li>

            {user.userType === 'admin' ? (
              <>
                {/* <li className={(inputMenu === "subadmins") ? "active" : ""} onClick={(e) => makeActive("subadmins", e)}><Link to="/admin/subadmin-managment"><i className="icon-users"></i><span>Sub Admins</span></Link></li> */}
                <li className={(inputMenu === "users") ? "active" : ""} onClick={(e) => makeActive("users", e)}><Link to="client-managment"><i className="icon-users"></i><span>User Managment</span></Link></li>
                <li className={(inputMenu === "projects") ? "active" : ""} onClick={(e) => makeActive("projects", e)}>
                  <Link to="/admin/manage-projects"><i className="icon-book-open"></i><span>Projects</span></Link>
                </li>
                <li className={(inputMenu === "payments") ? "active" : ""} onClick={(e) => makeActive("payments", e)}><Link to="/admin/payment-history"><i className="icon-calendar"></i><span>Payment</span></Link></li>
                <li className={(inputMenu === "email-managment") ? "active" : ""} onClick={(e) => makeActive("email-managment", e)}><Link to="email-management"><i className="icon-note"></i><span>Email Managment</span></Link></li>
                <li className={(inputMenu === "subscription") ? "active" : ""} onClick={(e) => makeActive("subscription", e)}><Link to="/admin/subscription-managment"><i className="icon-list"></i><span>Subscription Plan</span></Link></li>

                <li onClick={() => handleChangeMenu(displayBlock)} className={(inputMenu === "masters") ? "active" : ""}>
                  <a style={{ cursor: 'pointer' }} className='text-hover cursor-pointer'><i className="icon-grid"></i><span>Manage Masters</span></a>
                  <ul style={{ display: displayBlock }}>
                    <li className={(inputMenu === "objective") ? "active" : ""} onClick={(e) => makeActive("objective", e)}>
                      <Link to='/admin/manage-objective'><span>Objective</span></Link></li>
                    <li className={(inputMenu === "audience") ? "active" : ""} onClick={(e) => makeActive("audience", e)}><Link to='/admin/manage-audience'><span>Audience</span></Link></li>
                  </ul>
                </li>

                {/* <li><Link to="/admin/manage-content"><i className="icon-list"></i><span>Manage Content</span></Link></li> */}
              </>
            ) : (<></>)}

            {user.userType === 'subadmin' ? (
              <>
                {/* <li className={(inputMenu === "user") ? "active" : ""} onClick={(e)=>makeActive("user", e)}><Link to="client-managment"><i className="icon-users"></i><span>User Managment</span></Link></li>
                        <li className={(inputMenu === "subscription") ? "active" : ""} onClick={(e)=>makeActive("subscription", e)}><Link to="/admin/subscription-managment"><i className="icon-list"></i><span>Subscription Plan</span></Link></li>    */}
                {/* <li className={(inputMenu === "projects") ? "active" : ""} onClick={(e)=>makeActive("projects", e)}><Link to="#"><i className="icon-book-open"></i><span>Projects</span></Link></li>*/}
                {/* <li className={(inputMenu === "payment") ? "active" : ""} onClick={(e)=>makeActive("payment", e)}><Link to="/admin/payment-history"><i className="icon-calendar"></i><span>Payment</span></Link></li>  */}
              </>
            ) : (<></>)}
          </ul>
        </nav>
      </div>
    </div>
  );
}
export default Sidebar;